<template>
    <div :class="[outerClass, colSize]">
        <label v-if="label"
               class="block"
               :class="{ 'required-label': hasRequiredAttr, [labelClass]: true }"
               :style="labelStyle">{{
                __(label)
            }}</label>
        <InputText :disabled="isFormDisabled"
                   :name="fieldName"
                   :validation="validation"
                   class="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black-500/50"
                   autocomplete="off"
                   :class="{ 'required-field': hasRequiredAttr, [inputClass]: true }"
                   :style="inputStyle"
                   v-focus="isFocus"
                   v-model="field" />
        <small v-if="helperText">{{ __(helperText) }}</small>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import InputText from 'primevue/inputtext';
import { __ } from '@pages/Helper/utils.js'

const props = defineProps({
    fieldName: {
        type: String,
        required: true,
    },
    validation: {
        type: [Array, String],
        default: null,
    },
    label: {
        type: String,
        default: null,
    },
    size: {
        type: String,
        default: null
    },
    isFocus: {
        type: Boolean,
        default: false
    },
    isFormDisabled: {
        type: Boolean,
        default: false
    },
    helperText: {
        type: String,
        default: null
    },
    disabled: {
        type: Boolean,
        default: false
    },
    inputStyle: {
        type: [Object, String],
        default: null
    },
    inputClass: {
        type: String,
        default: null
    },
    labelClass: {
        type: String,
        default: null
    },
    labelStyle: {
        type: [Object, String],
        default: null
    },
    inRepeater: {
        type: Boolean,
        default: false
    },
});

const field = defineModel('field');
const validation = ref(Array.isArray(props.validation) ? props.validation : [props.validation]);
const colSize = props?.size ? 'col-' + props.size : 'col';
const hasRequiredAttr = validation.value.includes('required');
const outerClass = ref('field');

if (props.inRepeater) {
    outerClass.value = null;
}

</script>

<style lang="scss" scoped></style>
